import React from "react";
import { Dialog } from "@/components/Dialog";
import { Business } from "@norma-bi/bi-api";

export type RenameDialogProps = {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  business: Business;
  onConfirm: (newDisplayName: string) => void;
  isConfirmPending?: boolean;
};

export function RenameDialog({
  show,
  setShow,
  business,
  onConfirm,
  isConfirmPending = false,
}: RenameDialogProps) {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [displayName, setDisplayName] = React.useState(business.display_name);

  React.useEffect(() => {
    setDisplayName(business.display_name);
  }, [business]);

  React.useEffect(() => {
    if (show) {
      inputRef.current?.focus();
    }
  }, [show]);

  const isDisabled =
    displayName.trim() === "" || displayName === business.display_name || isConfirmPending;

  return (
    <Dialog
      show={show}
      message={
        <>
          <div className="mb-2 text-xs text-dark">Display Name</div>
          <input
            ref={inputRef}
            id="displayName"
            type="text"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            className="w-full bg-pureWhite border border-lightGray outline-none text-dark rounded-lg p-2 mb-2.5"
            placeholder="Enter display name"
          />
        </>
      }
      confirmButton={{
        text: "Submit",
        disabled: isDisabled,
        onClick: () => onConfirm(displayName),
      }}
      onDismiss={() => setShow(false)}
      showBorder={false}
    />
  );
}
